import { render, staticRenderFns } from "./BaseNotifications.vue?vue&type=template&id=7f05adba&"
import script from "./BaseNotifications.vue?vue&type=script&lang=js&"
export * from "./BaseNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports